// frontend/src/components/StripeCheckout.jsx
// ✅ Stripe Checkout integration for credit purchases

import React from "react";
import { apiPost, toast } from "../lib/api";

export default function StripeCheckout({ credits, onSuccess, onCancel, disabled }) {
  const [loading, setLoading] = React.useState(false);

  const handleCheckout = async () => {
    if (!credits || credits < 1) {
      toast("Please select a valid amount of credits");
      return;
    }

    try {
      setLoading(true);

      // Create Stripe Checkout session
      const response = await apiPost("/api/stripe/create-checkout-session", {
        credits: Number(credits),
      });

      const { url } = response;

      if (!url) {
        throw new Error("No checkout URL returned");
      }

      // Redirect to Stripe Checkout using the URL
      window.location.href = url;

    } catch (err) {
      console.error("[Stripe] Checkout error:", err);
      toast(err?.message || "Failed to start checkout");
      setLoading(false);
    }
  };

  return (
    <button
      className="btn btn-primary"
      onClick={handleCheckout}
      disabled={disabled || loading}
      style={{ width: "100%" }}
    >
      {loading ? "Redirecting to checkout..." : "Proceed to Payment"}
    </button>
  );
}